import { useNavigate } from "react-router-dom";
import { AlertCircleIcon } from "lucide-react"; // Icono de error
import { trn } from "../shared/i18n";

const ErrorScreen = () => {
  const navigate = useNavigate();

  return (
    <div className="fullscreen-container text-center">
      <div className="fullscreen-content">
        <h1 className="text-danger">
          <AlertCircleIcon size={48} /> {trn("app.consumer.error.title", "Error")}
        </h1>
        <p className="mt-3">{trn("app.consumer.error.body", "There was a problem loading the application.")}</p>
        <button className="btn btn-primary btn-lg mt-4" onClick={() => navigate("/setup")}>
          {trn("app.consumer.error.retry_setup", "Retry setup")}
        </button>
      </div>
    </div>
  );
};

export default ErrorScreen;
